import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { LOOM_URI, ROOT_PAGE } from 'constants/routes';
import { sendInactiveVideoOwnerPing } from 'creators/videoPlayer';

import Button from 'components/ui-components/button';
import Modal from 'components/ui-components/modal';

import './style.less';

class InactiveModal extends Component {
  state = {
    ownerPinged: false,
  };

  render() {
    const { ownerName = 'the owner', ThumbDiv = '' } = this.props;

    const notPingedContent = (
      <Fragment>
        <div className="inactive-video-modal-title">
          This video is currently inactive.
        </div>
        <div className="inactive-video-modal-content">
          {`We'll let ${ownerName} know you'd like to watch their video.`}
        </div>
        <div className="inactive-video-modal-actions">
          <Button
            onClicked={this.pingOwner}
            buttonType="rp-primary-2"
            value="Yes! Let them know."
          />
          <a href={LOOM_URI} className="inactive-video-modal-goto">
            go to loom.com
          </a>
        </div>
      </Fragment>
    );

    const pingedContent = (
      <Fragment>
        <div className="inactive-video-modal-title">Thanks!</div>
        <div className="inactive-video-modal-content">
          Your request is on its way! 🚀
        </div>
        <div className="inactive-video-modal-actions">
          <Button
            onClicked={this.goToLoom}
            buttonType="rp-primary-2"
            value="Go to loom.com"
          />
        </div>
      </Fragment>
    );

    return (
      <div className="video-player-container">
        {ThumbDiv}
        <Modal showClose={false} dark={true} show={true}>
          {this.state.ownerPinged ? pingedContent : notPingedContent}
        </Modal>
      </div>
    );
  }

  goToLoom = () => (window.location.pathname = ROOT_PAGE);

  pingOwner = () => {
    this.props.sendInactiveVideoOwnerPing();

    this.setState({ ownerPinged: true });
  };
}

const mapDispatchToProps = dispatch => {
  return {
    sendInactiveVideoOwnerPing: () => dispatch(sendInactiveVideoOwnerPing()),
  };
};

export default connect(null, mapDispatchToProps)(InactiveModal);
